export default {
  init() {
    // JavaScript to be fired on the locals archive
   
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/locals.js